import { ReactNode } from "react";
import { VersionMajorMinor } from "../logic/Versions";

export type ExternalLinkProps = {
    href: string,
    children?: ReactNode | undefined;
}

export const ExternalLinkVersionPattern = '{version}'

export const FormatExternalLink = (href: string) => {
    if(href.indexOf('9.5') >= 0 || href.indexOf('10.0') >= 0 || href.indexOf('11.0') >= 0) {
        throw 'Hardcoded version detected'
    }    
    return href.replace(ExternalLinkVersionPattern, VersionMajorMinor)
}

const ExternalLink = ({ href, children }: ExternalLinkProps) => {
    href = FormatExternalLink(href)
    return <a href={href} target="_blank" rel="noreferrer" className="external">{children}</a>;
}

export default ExternalLink